import { type ReadonlyDeep } from 'type-fest';

import { cloneDeep, isNil } from '#packages/data-collection/libs/lodash';

export const deepFreeze = <T = unknown>(obj: T): ReadonlyDeep<T> => {
  const propNames = Object.getOwnPropertyNames(obj);

  for (const name of propNames) {
    const value = (obj as any)[name];

    // Skip null or undefined values
    if (isNil(value)) {
      continue;
    }

    // Recursively freeze properties that are objects and not already frozen
    if (typeof value === 'object' && Object.isFrozen(value) === false) {
      deepFreeze(value);
      continue;
    }
  }

  return Object.freeze(obj) as ReadonlyDeep<T>;
};

export const deepClone = <T>(obj: T): T => cloneDeep(obj);
